import React, {useEffect, useRef, useState} from "react";
import "./style.css";
import leftArrow from "../../../assets/images/left-arrow.svg";
import fileUpload from "../../../assets/images/file-upload.svg";
import plus from "../../../assets/images/lecture/plus.svg";
import minus from "../../../assets/images/lecture/minus.svg";
import TextEditor from "../../notice/textEditor/TextEditor";
import {LectureDto, RefundRuleDto} from "../dto/Lecture.dto";
import {PopupProps} from "../../common/popup/Popup.props";
import Popup from "../../common/popup/Popup";
import {useLocation, useNavigate} from "react-router";
import axios from "axios";
import {GRAPHQL, LECTURE_ADD, LECTURE_UPLOAD} from "../../../constants/ApiUrl";
import {LECTURE} from "../../../constants/Routes";
import {GET_LECTURE_DETAIL_QUERY} from "../../../constants/query/Lecture.query";
import DatePicker from "react-datepicker";
import "./datepicker.css";
import {ko} from "date-fns/esm/locale";
import {DateParser} from "../../../util/DateParser";


export default function Detail() {
    const location = useLocation();
    const navigate = useNavigate();
    const [lectureDto, setLectureDto] = useState<LectureDto>(new LectureDto());
    const [titleLength, setTitleLength] = useState<number>(0);
    const [thumbnailImage, setThumbnailImage] = useState<string>("");
    const [thumbnailFile, setThumbnailFile] = useState<File | null>(null);
    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);

    const imgRef: any = useRef();

    const defaultRefundRules = [
        new RefundRuleDto(14, 50),
        new RefundRuleDto(7, 10),
        new RefundRuleDto(2, 0)
    ];

    useEffect(() => {
        if (location.state.seq !== 0) {
            axios.post(GRAPHQL, {
                query: GET_LECTURE_DETAIL_QUERY(location.state.seq)
            }).then(response => {
                const lectureDto = response.data.data.getLecture;

                setLectureDto(lectureDto);
                setTitleLength(lectureDto.title.length);
                setThumbnailImage(lectureDto.thumbnailFileName);
            });
        }
    }, []);

    useEffect(() => {
        if (!lectureDto.refundRules || lectureDto.refundRules.length === 0) {
            setLectureDto({...lectureDto, refundRules: defaultRefundRules});
        }
    }, [lectureDto]);

    const handleLectureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;

        if (name === "title") {
            setTitleLength(value.length);
        }

        setLectureDto(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleContentChange = (content: string) => {
        setLectureDto(prevState => ({
            ...prevState,
            content: content
        }));
    };

    const handleExpiredDateChange = (date: Date | null) => {
        if (date) {
            setLectureDto(prevState => ({
                ...prevState,
                expiredDate: DateParser.parseDate(date.toString())
            }));
        }
    }

    const onButtonClick = () => {
        let message1 = "";
        let message2 = "";

        if (lectureDto.title.replace(/\s/g, "") === "") {
            message1 = "강의명을 입력해주세요.";
        } else if (titleLength > 29) {
            message1 = "강의명은 30자 미만으로 입력해주세요.";
        } else if (lectureDto.content.replace(/<p>|<\/p>|\s|<br>/g, "") === "") {
            message1 = "강의 내용을 입력해주세요.";
        } else if (lectureDto.expiredDate === "") {
            message1 = "모집 마감일을 입력해주세요.";
        } else if (lectureDto.price < 0) {
            message1 = "유효한 숫자를 입력해주세요.";
        } else if (lectureDto.capacity < 1) {
            message1 = "1명 이상의 모집인원을 입력해주세요.";
        } else if (!isValidDate(lectureDto.expiredDate)) {
            message1 = "날짜 형식이 잘못되었습니다.";
            message2 = "날짜 형식은 YYYY-MM-DD 입니다.";
        } else if (!isValidRefundRate()) {
            message1 = "환불 조건이 잘못되었습니다.";
            message2 = "0% 이상 100% 이하의 조건만 작성해주세요.";
        } else if (!isValidRefundLeftDays()) {
            message1 = "환불 조건이 잘못되었습니다.";
            message2 = "중복된 환불요청시점이 존재합니다.";
        } else if (!isValidImageFile()) {
            message1 = "썸네일 이미지 확장자가 잘못되었습니다.";
            message2 = "이미지 파일만 등록해주세요.";
        } else {
            if (thumbnailFile) {
                const formData = new FormData();
                formData.append("thumbnailFile", thumbnailFile);
                formData.append("lectureDto", JSON.stringify(lectureDto));

                axios.post(LECTURE_UPLOAD, formData, {headers: {"Content-Type": "multipart/form-data"}}).then(() => {
                    navigate(LECTURE);
                });
            } else {
                axios.post(LECTURE_ADD, lectureDto).then(() => {
                    navigate(LECTURE);
                });
            }

            return;
        }

        setPopupProps({
            subject: location.state.seq === 0 ? "강의 등록" : "강의 수정",
            message1: message1,
            message2: message2,
            buttonName: "확인",
            onConfirm: () => setPopupProps(null),
            useCloseButton: false,
            onClose: () => setPopupProps(null)
        });
    };

    const isValidDate = (date: string) => {
        const regex: RegExp = /^\d{4}-\d{2}-\d{2}$/;
        return regex.test(date);
    };

    const isValidRefundRate = (): boolean => {
        for (let i = 0; i < lectureDto.refundRules.length; i++) {
            if (lectureDto.refundRules[i].rate > 100 || lectureDto.refundRules[i].rate < 0) {
                return false;
            }
        }
        return true;
    };

    const isValidRefundLeftDays = (): boolean => {
        for (let i = 0; i < lectureDto.refundRules.length; i++) {
            for (let j = i + 1; j < lectureDto.refundRules.length; j++) {
                if (lectureDto.refundRules[i].leftDays === lectureDto.refundRules[j].leftDays) {
                    return false;
                }
            }
        }

        return true;
    };

    const isValidImageFile = (): boolean => {
        const imageForm: RegExp = /(.*?)\.(jpg|jpeg|png|gif|bmp|pdf|svg|tiff|jfif|webp|svgz|xbm|dib|pjp|apng|tif|pjpeg|avif)$/;
        if (thumbnailFile) {
            return thumbnailFile.name.match(imageForm) !== null;
        }

        return true;
    }

    const onChangeRefundLeftDays = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = event.target;
        const refundRules = lectureDto.refundRules;

        refundRules[index].leftDays = Number(value.split(" ")[1].split("일")[0]);

        setLectureDto({...lectureDto, refundRules: refundRules});
    };

    const onChangeRefundRate = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = event.target;
        const refundRules = lectureDto.refundRules;

        refundRules[index].rate = Number(value);

        setLectureDto(prevState => ({
            ...prevState,
            refundRules: refundRules
        }));
    };

    const onMinusButtonClick = (index: number) => {
        const refundRules = lectureDto.refundRules;
        refundRules.splice(index, 1);

        setLectureDto(prevState => ({
            ...prevState,
            refundRules: refundRules
        }));
    };

    const onPlusButtonClick = () => {
        const refundRules = lectureDto.refundRules;
        refundRules.push(new RefundRuleDto(0, 0));

        setLectureDto(prevState => ({
            ...prevState,
            refundRules: refundRules
        }));
    };

    const onChangeThumbnail = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file: File | null = event.target.files ? event.target.files[0] : null;

        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setThumbnailImage(reader.result as string);
                setThumbnailFile(file)
            };
        }
    };

    return (
        <>
            <div className="lecture-add">
                <main className="wrapper">
                    <div className="lecture-add-body">
                        <div className="lecture-add-title">
                            <button className="arrow" onClick={() => navigate(LECTURE)}>
                                <img src={leftArrow} alt="arrow"/>
                            </button>
                            <div className="text" data-testid="title">
                                {location.state.seq === 0 ? "강의 추가 개설" : "강의 상세"}
                            </div>
                        </div>
                        <div className="lecture-add-box">
                            <div className="left">
                                <div className="lecture-name">
                                    <div className="lecture-info-title">
                                        강의명
                                    </div>
                                    <div className="input-wrapper">
                                        <input
                                            name="title"
                                            placeholder="강의명을 입력해주세요"
                                            className="lecture-info-input"
                                            defaultValue={lectureDto.title} onChange={handleLectureChange}
                                        />
                                        <div className="number">
                                            {titleLength}/29
                                        </div>
                                    </div>
                                </div>
                                <div className="lecture-wrapper">
                                    <div className="lecture-deadline">
                                        <div className="lecture-info-title">
                                            모집 마감일
                                        </div>
                                        <DatePicker
                                            className="date-picker"
                                            name="expiredDate"
                                            selected={lectureDto.expiredDate ? new Date(lectureDto.expiredDate) : null}
                                            dateFormat="yyyy-MM-dd"
                                            locale={ko}
                                            minDate={new Date()}
                                            onChange={(date) => handleExpiredDateChange(date)}
                                            autoComplete="off"
                                        />
                                            </div>
                                                <div className="lecture-pay">
                                                    <div className="lecture-info-title">
                                                        인당 강의료
                                                    </div>
                                                    <input
                                                        name="price"
                                                        placeholder="숫자만 입력"
                                                        type="number"
                                                        className="lecture-info-input"
                                                        value={lectureDto.price}
                                                        onChange={handleLectureChange}
                                                        data-testid="lecture-price"/>
                                                </div>
                                </div>
                                <div className="lecture-personnel">
                                    <div className="lecture-info-title">
                                        모집인원
                                    </div>
                                    <input
                                        name="capacity"
                                        placeholder="숫자만 입력"
                                        type="number"
                                        className="lecture-info-input"
                                        value={lectureDto.capacity}
                                        onChange={handleLectureChange}
                                        data-testid="lecture-capacity"
                                    />
                                </div>
                            </div>
                            <div className="right">
                                <div className="button-file-upload">
                                    <div className="lecture-info-title">
                                        썸네일 이미지
                                    </div>
                                    <label className="image-box">
                                        {
                                            !thumbnailImage && (
                                                <>
                                                    <img src={fileUpload} alt="icon"/>
                                                    <div className="sub">
                                                        이미지 업로드
                                                    </div>
                                                    <div className="sub-text">
                                                        이미지 파일 / 564x475px 권장
                                                    </div>
                                                </>
                                            )
                                        }
                                        {
                                            thumbnailImage && (
                                                <div className="thumbnail-img">
                                                    <img src={thumbnailImage} alt="icon" data-testid="thumbnail"/>
                                                </div>
                                            )
                                        }
                                        <input
                                            type="file"
                                            className="file"
                                            accept="image/*"
                                            onChange={onChangeThumbnail}
                                            ref={imgRef}
                                            data-testid="file-uploader"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="notice-post-box">
                            <TextEditor content={lectureDto.content} onChange={handleContentChange} data-testid="text-editor"/>
                        </div>

                        <div className="lecture-refund">
                            <div className="title">
                                강의 환불 규정
                            </div>
                            <div className="refund-title-wrapper">
                                <div className="title">
                                    환불요청시점
                                </div>
                                <div className="title">
                                    환불금액
                                </div>
                            </div>
                            <div className="refund-wrapper">
                                {
                                    lectureDto.refundRules.map((refundRule, index) => {
                                        return (
                                            <div className="refund-box" key={index} data-testid="refund-rule">
                                                <input
                                                    type="text"
                                                    placeholder="직접 입력"
                                                    value={`수강일 ${refundRule.leftDays}일 이내`}
                                                    onChange={e => onChangeRefundLeftDays(index, e)}
                                                    data-testid="refund-leftdays"
                                                />
                                                <input
                                                    type="number"
                                                    placeholder="숫자입력"
                                                    value={refundRule.rate}
                                                    onChange={e => onChangeRefundRate(index, e)}
                                                />
                                                <div className="percent">
                                                    %
                                                </div>
                                                <button className="cancel-button"
                                                        onClick={() => onMinusButtonClick(index)}
                                                        data-testid="delete-refund">
                                                    <img src={minus} alt="cancel-button"></img>
                                                </button>
                                                {
                                                    index === lectureDto.refundRules.length - 1 && (
                                                        <button className="add-button"
                                                                onClick={onPlusButtonClick}
                                                                data-testid="add-refund">
                                                            <img src={plus} alt="plus"/>
                                                        </button>
                                                    )
                                                }
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>

                        <div className="button-wrapper">
                            <button className="submit-button" onClick={onButtonClick} data-testid="register">
                                등록
                            </button>
                        </div>
                    </div>
                </main>
            </div>
            {
                popupProps && (
                    <Popup data={popupProps}></Popup>
                )
            }
        </>
    );
}